import ContentLoader from 'react-content-loader';
import { TextLoader } from '../Text/TextLoader';

interface IProps {
  numberOfLoaders?: number;
}

export const NearbyTopSpeciesLoader = ({ numberOfLoaders = 3 }: IProps) => {
  return (
    <div className="flex flex-col gap-1 pb-10">
      <TextLoader uniqueKey={'nearby-top-species-title'} width="33%" />
      <div className="flex flex-col gap-2.5">
        {Array.from({ length: numberOfLoaders }).map((_, index) => (
          <ContentLoader
            key={`nearby-top-species-loader-${index}`}
            uniqueKey={`nearby-top-species-loader-${index}`}
            width="100%"
            height="100%"
            className={`h-16 min-h-16 w-full md:h-12 md:min-h-12`}
          >
            <rect x="0" y="0" rx="4" ry="4" width="100%" height="100%" />
          </ContentLoader>
        ))}
      </div>
    </div>
  );
};
